import axios from 'axios'
import { FetchProducersQuery, Producer } from 'types/producer'
import { stringify } from 'qs'
import { filterAndSortProducers } from 'utils/producers'
import { GetProducersResponse } from 'types/bolt-api/request'

/**
 * Get all producers
 *
 * @param {FetchProducersQuery} filters
 * @returns {Promise<Producer[]>}
 */
const getProducers = async ({ language, params }: FetchProducersQuery): Promise<Producer[]> => {
  try {
    const query = stringify(params, { addQueryPrefix: true, skipNulls: true })
    const { data } = await axios.get<GetProducersResponse>(`${process.env.API_URL}/producers${query}`, {
      headers: {
        Authorization: `Basic ${process.env.API_TOKEN}`
      }
    })

    return data?.producers ? filterAndSortProducers({ hideSoldOut: params?.soldOut === false, language, producers: data.producers }) : []
  } catch (_) {
    return []
  }
}

export default getProducers
